import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getMapLayers } from '../../services/backend';
import { bannerColor, headerColor, backgroundGrey } from '../../style/colors';
import OlMap from '../OpenLayers/Map';
import { osm, getWMTS, tileWMS } from '../OpenLayers/Source';
import { Layers, TileLayer } from '../OpenLayers/Layers';
import {
    Controls,
    MousePositionControl,
    ScaleLineControl,
    ZoomControl,
    FullScreenControl,
} from '../OpenLayers/Controls';
// import OnClickEvent from '../OpenLayers/Interaction/OnClick';
import {
    center,
    initialZoom,
    defaultMapProjection,
    minZoom,
    maxZoom,
} from '../OpenLayers/config';

const StyledMap = styled(OlMap)`
    height: calc(100vh - 90px);
    background-color: ${backgroundGrey};

    & .ol-full-screen {
        top: 8px;
        right: 8px;
    }

    & .ol-mouse-position {
        position: absolute;
        bottom: 8px;
        left: 8[x];
        background-color: rgba(255, 255, 255, 0.4);
        border-radius: 4px;
        padding: 2px;
    }
`;

const ContentContainer = styled.div`
    background: ${backgroundGrey};
    width: 100%;
    height: 100%;
`;
const MainContainer = styled.div`
    background: ${bannerColor};
    width: 100%;
    height: 90px;
`;

const HeaderText = styled.div`
    position: absolute;
    top: 0;
    height: 65;
    left: calc((80vw / 2));
    color: ${headerColor};
    background: ${bannerColor};
    overflow: auto;
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 24px;
    font-weight: bold;
    z-index: 2;
`;

const ExampleMap = () => {
    const [availableLayers, setAvailableLayers] = useState([]);
    // not used: const [visibleLayers, setVisibleLayers] = useState([]);

    // const activeLayer = visibleLayers.length
    //     ? availableLayers.find(
    //           (layer) =>
    //               layer.layerid === visibleLayers[visibleLayers.length - 1]
    //       )
    //     : null;
    useEffect(() => {
        getMapLayers().then((data) => {
            Promise.all(
                data.map(async (layer) => {
                    let source;
                    if (layer.protocol === 'wmts') {
                        source = await getWMTS(
                            layer.onlineresource,
                            layer.layername
                        ).catch((error) => {
                            console.error(error);
                        });
                    } else {
                        source = tileWMS({
                            url: layer.onlineresource,
                            params: { layers: layer.layername },
                        });
                    }
                    return {
                        ...layer,
                        source,
                    };
                })
            ).then((initializedLayers) => {
                setAvailableLayers(initializedLayers);
                // setVisibleLayers([1, 2, 3]); // layerids of layers to show, replaced by check for layer.visible > 0 below
            });
        });
    }, []);

    return (
        <ContentContainer>
            <MainContainer>
                <HeaderText>
                    Overview of the CocoaSoils sites
                    {/* <Countries /> */}
                </HeaderText>
            </MainContainer>
            <StyledMap
                center={center}
                zoom={initialZoom}
                minZoom={minZoom}
                maxZoom={maxZoom}
                // dimensions={mapDimensions}
                projection={defaultMapProjection}
            >
                <Layers>
                    {/* background layer: */}
                    <TileLayer source={osm()} zIndex={0} />

                    {/* visible layers: */}
                    {availableLayers
                        .filter(
                            (layer) =>
                                // visibleLayers.includes(layer.layerid)   // replaced by:
                                layer.visible > 0
                        )
                        .map((layer) => {
                            return (
                                <TileLayer
                                    key={layer.layerid}
                                    // extent={layer.extent}
                                    source={layer.source}
                                    // zIndex={layer.orderGroup}
                                    zIndex={1}
                                    // opacity={layerState[layer.layerid]?.opacity}
                                />
                            );
                        })}
                </Layers>

                <Controls>
                    <FullScreenControl />
                    <MousePositionControl />
                    <ScaleLineControl />
                    <ZoomControl />
                </Controls>

                {/* user interactions / events: */}
                {/* {activeLayer && (
                <OnClickEvent
                    layerSource={activeLayer.source}
                    layerName={activeLayer.name}
                    layerFeatureInfoUrl={activeLayer.featureinfourl}
                    onClickFunc={(...args) => console.log(args)}
                    getFeatureInfo={true}
                    // onClickStart={() => {
                    //     setShowLoadingCursor(true);
                    // }}
                    // onClickFinal={() => {
                    //     setShowLoadingCursor(false);
                    // }}
                />
            )} */}
            </StyledMap>
        </ContentContainer>
    );
};

export default ExampleMap;
